import React, { useState, useEffect } from "react";
import { Button, Text } from "components";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function DeliveryChallanEwayBillCancel() {
  const [visible, setvisible] = useState(true);
  const [taxinfo, setTaxInfo] = useState({});
  const { id } = useParams();
  let navigate = useNavigate();

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  useEffect(() => {
    GetTaxInvoiceIRNEwayNo();
  }, []);

  const GetTaxInvoiceIRNEwayNo_obj = { id: id };
  const GetTaxInvoiceIRNEwayNo = () => {
    axios
      .post(
        "/api/purple-fusion/delivarychallan/get",
        GetTaxInvoiceIRNEwayNo_obj,
        headers
      )
      .then((response) => {
        console.log(response.data);
        setTaxInfo(response.data[0]);
        formik.setFieldValue("ewbNo", response.data[0].ewbno);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const validationSchema = Yup.object().shape({
    ewbNo: Yup.string().required("Eway bill number is Required"),
    CnlRem: Yup.string().required("Please select the reason"),
  });

  const formik = useFormik({
    initialValues: {
      ewbNo: "",
      CnlRsn: "",
      CnlRem: "",
      id: id,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });
  const options = [
    { value: "1", label: "Duplicate" },
    { value: "2", label: "Order Cancelled" },
    { value: "3", label: "Data Entry Mistake" },
    { value: "4", label: "Others" },
  ];

  const handleFormSubmit = (values) => {
    console.log(values);
    const errorMessage = `<a target="_blank" href="https://docs.ewaybillgst.gov.in/apidocs/api-error-codes-list.html"  style="color: #00f; text-decoration: underline;">Error List</a>`;
    // axios
    //   .post("/api/purple-fusion/einvoice/cancelinvoice", values, headers)
    //   .then((response) => {
    //     console.log(response.data);
    //     const successmessage = response.data.message;
    //     let message = response.data.message;
    //     message = message.replace(/[\[\]{}\/\\"']/g, "");
    //     message = message.replace(/[\,\;]/g, "\n");
    //     console.log(message);
    //     response.data.status
    //       ? toast.success(successmessage, {
    //           autoClose: 2000,
    //           onClose: () => {
    //             //   setvisible(false);
    //             navigate(`/taxinvoice/cancel/list`);
    //           },
    //         })
    //       : toast.error(
    //           <div
    //             dangerouslySetInnerHTML={{ __html: message + errorMessage }}
    //           />,
    //           {
    //             autoClose: 2000,
    //           }
    //         );
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     //   setvisible(false);
    //     //   navigate("*");
    //   });
  };

  const customStyles = {
    content: {
      width: "75%",
      height: "75%",
      margin: "auto",
      borderRadius: "10px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
  };
  return (
    <>
      <Modal isOpen={visible} style={customStyles}>
        <form onSubmit={formik.handleSubmit}>
          <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
            <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
              <div className="flex flex-1 flex-col gap-[12px] justify-start md:px-5 w-full">
                <div className=" flex flex-row w-[100%]">
                  <div className="flex flex-row sm:gap-15 items-center justify-start w-full ">
                    <Text
                      className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px] "
                      size="txtInterMedium24"
                    >
                      Cancel Delivery Challan
                    </Text>
                  </div>
                  <div className="flex flex-row items-center justify-start">
                    <Button
                      className="cursor-pointer font-small mb-1.5 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px] active:scale-90 transition-transform duration-200"
                      shape="round"
                      color="blue_A700"
                      size="base"
                      variant="fill"
                      type="submit"
                      // onClick={(e) => onHandleSubmit(e)}
                    >
                      Save
                    </Button>
                    <Button
                      className="cursor-pointer sticky font-small mb-2 min-w-[70px] rounded-[7px] text-center text-lg tracking-[0.20px]"
                      shape="round"
                      color="white"
                      size="base"
                      variant="fill"
                      onClick={() => {
                        setvisible(false);
                        navigate(`/delivarychallan/list`);
                      }}
                    >
                      ╳
                    </Button>
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-medium mb-1 ml-4">
                    Delivery Challan Details
                  </h3>
                  <div className="m-4 p-3 border rounded-lg">
                    <div className="grid grid-cols-3 gap-y-2 items-center justify-between">
                      <label className="block text-sm font-medium text-gray-900">
                        Customer Name: {taxinfo.customer_name}
                      </label>
                      <label className="block text-sm font-medium text-gray-900">
                        DC Date: {taxinfo.delivery_challan_date}
                      </label>
                      <label className="block text-sm font-medium text-gray-900">
                        Delivery Challan No.: {taxinfo.code}
                      </label>
                      <label className="block text-sm font-medium text-gray-900">
                        Delivery challan type:{" "}
                        {taxinfo?.delivery_challan_type_name}
                      </label>
                      <label className="block text-sm font-medium text-gray-900">
                        DC E-way Bill valid till: {taxinfo?.ewbvalidtill}
                      </label>
                      <label className="block text-sm font-medium text-gray-900">
                        E-way Bill No.: {taxinfo?.ewbno}
                      </label>
                      <label className="block text-sm font-medium text-gray-900">
                        Remark: {taxinfo?.remark}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-start md:ml-[0] ml-[25px] w-[87%] md:w-full  ">
                  <ToastContainer />
                  <div className="flex flex-col items-center justify-start w-full">
                    <div className="md:gap-5 gap-x-[75px] gap-y-4 grid md:grid-cols-1 grid-cols-2 justify-center min-h-[auto] w-full mt-0">
                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                        <Text
                          className=" md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto"
                          size="txtInterMedium20Black900"
                        >
                          <span className="text-black-700 font-inter font-small text-sm">
                            DC E-way Bill No.
                          </span>
                          <span className="text-red-A700 font-inter font-small text-sm">
                            *
                          </span>
                        </Text>
                        <input
                          name="ewbNo"
                          type="text"
                          placeholder=" Enter ewbNo"
                          readOnly
                          // value={operation.name}
                          // onChange={handleInputChange}
                          value={formik.values.ewbNo}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="bg-white-A700 border border-gray-400_02 border-solid h-9 text-sm rounded-[5px] w-full"
                        ></input>
                        {formik.touched.ewbNo && formik.errors.ewbNo ? (
                          <div className="text-red-500 text-sm">
                            {formik.errors.ewbNo}
                          </div>
                        ) : null}
                      </div>

                      <div className="flex flex-1 flex-col gap-1 items-start justify-start w-full mt-0">
                        <label className="md:text-[22px] text-black-700 text-center sm:text-xl tracking-[0.28px] w-auto">
                          <span className="text-black-700 font-inter text-sm font-small">
                            Select Reason
                          </span>
                          <span className="text-red-A700 font-inter text-sm font-small">
                            *
                          </span>
                        </label>

                        <Select
                          name="CnlRem"
                          options={options}
                          className="bg-white-A700 border text-sm border-gray-200_02 border-solid h-[40px] rounded-[10px] w-full"
                          onChange={(selectedOption) => {
                            formik.setFieldValue(
                              "CnlRsn",
                              selectedOption.value
                            );
                            formik.setFieldValue(
                              "CnlRem",
                              selectedOption.label
                            );
                          }}
                          onBlur={formik.handleBlur}
                          placeholder="Select Reason for cancel"
                          value={options.find(
                            (option) => option.value === formik.values.CnlRem
                          )}
                        />

                        {formik.touched.CnlRem && formik.errors.CnlRem ? (
                          <div className="text-red-500">
                            {formik.errors.CnlRem}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default DeliveryChallanEwayBillCancel;
